import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { AuthProvider, TAuthConfig, TRefreshTokenExpiredEvent } from 'react-oauth2-code-pkce'
import { ApolloProvider } from './core/apollo_provider.tsx'
import { CurrentTenantProvider } from './core/current_tenant_context.tsx'
import { RouterProvider } from 'react-router'
import { router } from './router.tsx'
import posthog from 'posthog-js'
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'

const authConfig: TAuthConfig = {
  clientId: import.meta.env.VITE_RIPPLE_CLIENT_ID,
  authorizationEndpoint: import.meta.env.VITE_RIPPLE_AUTHORIZATION_ENDPOINT,
  tokenEndpoint: import.meta.env.VITE_RIPPLE_TOKEN_ENDPOINT,
  redirectUri: import.meta.env.VITE_RIPPLE_REDIRECT_URI,
  scope: '',
  decodeToken: false,
  onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => event.logIn(undefined, undefined, 'popup'),
}

const honeybadgerConfig = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_RIPPLE_ENV || 'production',
  revision: import.meta.env.VITE_VERSION
}

const honeybadger = Honeybadger.configure(honeybadgerConfig)

if (import.meta.env.VITE_RIPPLE_ENABLE_POSTHOG) {
  posthog.init(
    'phc_qvjSOrHBz5gIBh6mgVBcTlalUOEiFcjbmCpwbvQZHlB',
    {
      api_host: 'https://eu.i.posthog.com',
      person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
    }
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HoneybadgerErrorBoundary honeybadger={honeybadger} showUserFeedbackFormOnError={true}>
      <AuthProvider authConfig={authConfig}>
        <CurrentTenantProvider>
          <ApolloProvider>
            <RouterProvider router={router} />
          </ApolloProvider>
        </CurrentTenantProvider>
      </AuthProvider>
    </HoneybadgerErrorBoundary>
  </StrictMode>
)
